// @vendors
import { Carousel } from 'react-responsive-carousel';

// @styles 
import './styles.scss'
import { useState } from 'react';
import { Fade } from 'react-reveal';

export default function SliderClients({ data }) {
    const [currentSlide, setCurrentSlide] = useState(0);
    const info = data.primary
    const items = data.items

    const getConfigurableProps = () => ({
        showArrows: false,
        showStatus: false,
        showIndicators: false,
        infiniteLoop: true,
        showThumbs: false,
        useKeyboardArrows: true,
        autoPlay: false,
        stopOnHover: true,
        swipeable: true,
        dynamicHeight: false,
        emulateTouch: true,
        autoFocus: false,
        thumbWidth: 100,
        selectedItem: 1,
        interval: 2000,
        transitionTime: 500,
        swipeScrollTolerance: 6
    });

    const next = () => {
        setCurrentSlide(currentSlide + 1);
    };

    const prev = () => {
        setCurrentSlide(currentSlide - 1);
    };

    const updateCurrentSlide = (index) => {
        if (currentSlide !== index) {
            setCurrentSlide(index);
        }
    };

    return (
        <div className='sliderclients__container' id={info.idcontent}>
            <div className='container-xl'>
                <div className='sliderclients__container-content'>
                    <div className='sliderclients__container-content-title'>
                        <div className='sliderclients__container-content-title-img'>
                            <img src={info.image ? info.image.url : ""} alt={info?.image?.alt} />
                        </div>
                        <Fade right delay={0.3}>
                            <p>
                                {info.sectiontitle ? info.sectiontitle : ""}<br />

                            </p>
                        </Fade>
                    </div>
                    <div className='sliderclients__container-content-slider'>
                        <Carousel {...getConfigurableProps()} selectedItem={currentSlide} onChange={updateCurrentSlide}>
                            {
                                items && items.length > 0 && items.map((item, index) => (
                                    <div className='slide__content' key={index}>
                                        <div className='slide__content-text'>
                                            <p className='slide__content-text-description'>{item.message ? item.message : ""}</p>
                                            <p className='slide__content-text-name'>
                                                <td dangerouslySetInnerHTML={{ __html: item.name ? item.name : "" }} />
                                            </p>
                                        </div>
                                        <div className='sliderclients__container-content-slider-img'>
                                            <img src={item.photo ? item.photo.url : ''} alt={item?.photo?.alt} />
                                        </div>
                                    </div>
                                ))
                            }
                        </Carousel>
                        <div className='sliderclients__container-content-slider-buttons'>
                            <div className='sliderclients__container-content-slider-buttons-actions'>
                                <button
                                    data-testId="prev"
                                    onClick={prev}>
                                    <em className='fa-light fa-angle-left' />
                                </button>
                                <button
                                    data-testId="next"
                                    onClick={next}>
                                    <em className='fa-light fa-angle-right' />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}